import React from "react";
import flatCube from "assets/flat-cube.svg";

function LoaderShell(props) {
    return (
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl pt-40 text-center">
                <div className="absolute inset-y-1/3 inset-x-1/3 z-10">
                    <img
                        src={flatCube}
                        className="spinner d-block mx-auto"
                        alt="loading"
                    />
                    {props.statusMessage && (
                        <h1 className="mt-5 text-sm font-light text-gray-800">
                            {props.statusMessage}
                        </h1>
                    )}
                </div>
            </div>
        </div>
    );
}

export default LoaderShell;
